module.exports = __webpack_public_path__ + "img/template1.beee0d9e.png";